<template>
  <div class="characteristic-container">
    <h2>精彩视频</h2>
    <video id="my_video_1" class="video-content playVideo playVideo1 video-js vjs-default-skin vjs-big-play-centered" controls preload="auto"
      data-setup='{}' width="846px" height="520px" poster="../../assets/images/img_photo_poster.png">
      <source src="https://shs3.b.qianxin.com/qax-cms/7173ba7b4880f68f877d2c0d02d8f892.mp4">
    </video>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: '精彩视频'
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .video-js {
  background-color: #02021c;
}
/deep/ .vjs-poster {
  background-color: #02021c;
}
.characteristic-container {
  margin: 0 auto;
  width: 1150px;
  height: 650px;
  background: url(../../assets/images/bg_vedio_border.png) no-repeat 100% 100%;
  background-size: contain;
  h2 {
    position: relative;
    display: block;
    color: white;
    font-family: FZLTZHK;
    font-weight: normal;
    font-size: 24px;
    top: 30px;
  }
  .video-content {
    top: 40px;
    margin: 0 auto;
  }
}
</style>
